// ---------------------------------------------------------------------------
// CTA Banner Renderer
// ---------------------------------------------------------------------------

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text } from "../escape.js";
import { renderConversionActionControl } from "../conversion-action.js";

interface CtaBannerProps {
  id?: string;
  headline: string;
  subtext?: string;
  ctaText: string;
  actionUrl?: string;
  actionRef?: string;
  actionPayload?: Record<string, unknown> | string;
  openInNewTab?: boolean;
  variant?: "primary" | "secondary" | "accent";
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as unknown as CtaBannerProps;

  const headline = p.headline ?? "";
  const ctaText = p.ctaText ?? "Get Started";
  const variant = p.variant ?? "primary";

  const subtextHtml = p.subtext
    ? `\n    <p class="ease-cta-subtext">${text(p.subtext)}</p>`
    : "";
  const ctaHtml = renderConversionActionControl({
    props,
    label: ctaText,
    className: `ease-btn ease-btn-${variant} ease-cta-btn`,
    defaultUrl: "#form",
    componentType: "cta-banner",
    componentId: p.id,
  });

  return `<section class="ease-section ease-cta-banner ease-cta-banner--${attr(variant)}" aria-label="${attr(headline)}">
  <div class="ease-cta-content">
    <h2 class="ease-cta-headline">${text(headline)}</h2>${subtextHtml}
    ${ctaHtml}
  </div>
</section>`;
}

registerRenderer("cta-banner", { render });
